export default __webpack_public_path__ + "static/media/background_ic.65b3de1e.svg";